import React from 'react';
import { cn } from '@/lib/utils';
import { Message } from '../../types/chat';

interface StepMessageProps {
  message: Message;
}

const StepMessage = ({ message }: StepMessageProps) => {
  return (
    <div className="flex items-start space-x-3">
      <div className="w-8 h-8 bg-primary text-primary-foreground rounded-full flex items-center justify-center text-sm font-medium">
        {message.stepNumber}
      </div>
      <div className="flex-1">
        <div className={cn(
          "p-4 rounded-lg border transition-colors duration-200",
          message.completed 
            ? "bg-primary/10 border-primary/20 text-foreground" 
            : "bg-muted border-border text-muted-foreground"
        )}>
          <p className="text-sm">{message.content}</p>
          {message.completed && (
            <div className="mt-2 text-xs text-primary font-medium">✓ Completed</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StepMessage;